/**
 * @file コンポーネント：フル動画ページフル動画プレイヤー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledFullvideo = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &.is-loading {
        overflow: hidden;
    }
`;

export const StyledFullvideoContainer = styled.div`
    position: relative;
    z-index: 1;
    height: 100%;
`;

export const StyledFullvideoLoading = styled.div`
    position: absolute;
    z-index: ${zIndex.fullvideoLoading};
    width: 100%;
    height: 100%;
    background-color: #000000;
`;

export const StyledFullvideoMessage = styled.div`
    padding: 16px;
`;
